import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DoorOpen, Loader2, Save, Video } from "lucide-react";
import { api } from "@/auth/AuthContext";

const Toggle = ({ checked, disabled, onChange, testid }) => (
  <button type="button" role="switch" aria-checked={checked} disabled={disabled} data-testid={testid}
    className={`laksmi-toggle ${checked ? "on" : ""}`} onClick={() => onChange(!checked)}><span /></button>
);

export default function LaksmiAdmin() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [form, setForm] = useState({ zoom_link: "", meeting_id: "", passcode: "", notif_enabled: false });
  const [busy, setBusy] = useState("");
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    const res = await api.get("/laksmi/admin/settings");
    setData(res.data);
    setForm({ zoom_link: res.data.zoom_link, meeting_id: res.data.meeting_id, passcode: res.data.passcode, notif_enabled: res.data.notif_enabled });
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async (next) => {
    setBusy("save"); setError(""); setNotice("");
    try {
      const payload = next || form;
      const res = await api.put("/laksmi/admin/settings", payload);
      setForm({ zoom_link: res.data.zoom_link, meeting_id: res.data.meeting_id, passcode: res.data.passcode, notif_enabled: res.data.notif_enabled });
      setNotice("Pengaturan tersimpan.");
      await load();
    } catch (err) { setError(err.response?.data?.detail || "Gagal menyimpan."); }
    finally { setBusy(""); }
  };


  const openLaksmi = async () => {
    setBusy("open");
    try { await api.post("/laksmi/admin/open"); navigate("/laksmi/tamu"); }
    catch (err) { setError(err.response?.data?.detail || "Gagal membuka LAKSMI."); setBusy(""); }
  };
  const closeLaksmi = async () => { setBusy("close"); try { await api.post("/laksmi/admin/close"); await load(); } finally { setBusy(""); } };
  const toggleLibur = async (v) => {
    setBusy("libur"); setError("");
    try { await api.post(`/laksmi/admin/libur?active=${v}`); await load(); }
    catch (err) { setError(err.response?.data?.detail || "Gagal mengubah status libur."); }
    finally { setBusy(""); }
  };

  if (!data) return <div className="laksmi-page"><Loader2 className="laksmi-spin" /></div>;
  const st = data.state || {};

  return (
    <div className="laksmi-page laksmi-admin" data-testid="laksmi-admin-page">
      <div className="laksmi-admin-head"><h1>Kelola Layanan Konsultasi</h1><span className={`laksmi-pill ${st.is_open ? "open" : "closed"}`} data-testid="laksmi-open-state">{st.is_open ? "LAKSMI DIBUKA" : "LAKSMI DITUTUP"}</span></div>

      <section className="laksmi-card" data-testid="laksmi-meeting-card">
        <h2><Video size={16} /> Informasi Meeting</h2>
        <label className="laksmi-field"><span>Link Zoom Meeting</span><input value={form.zoom_link} data-testid="laksmi-zoom-link" placeholder="https://zoom.us/j/..." onChange={(e) => setForm((c) => ({ ...c, zoom_link: e.target.value }))} /></label>
        <div className="laksmi-grid2">
          <label className="laksmi-field"><span>Meeting ID</span><input value={form.meeting_id} data-testid="laksmi-meeting-id" onChange={(e) => setForm((c) => ({ ...c, meeting_id: e.target.value }))} /></label>
          <label className="laksmi-field"><span>Passcode</span><input value={form.passcode} data-testid="laksmi-passcode" onChange={(e) => setForm((c) => ({ ...c, passcode: e.target.value }))} /></label>
        </div>
        <button className="laksmi-primary ghost" data-testid="laksmi-save-settings" disabled={busy === "save"} onClick={() => save()}>{busy === "save" ? <Loader2 size={15} className="laksmi-spin" /> : <Save size={15} />} Simpan</button>
      </section>

      <section className="laksmi-card laksmi-actions-card">
        {st.is_open
          ? <button className="laksmi-primary danger" data-testid="laksmi-close-btn" disabled={busy === "close"} onClick={closeLaksmi}>Tutup LAKSMI</button>
          : <button className="laksmi-primary big" data-testid="laksmi-open-btn" disabled={busy === "open"} onClick={openLaksmi}>{busy === "open" ? <Loader2 size={18} className="laksmi-spin" /> : <DoorOpen size={18} />} BUKA LAKSMI</button>}
        <div className="laksmi-libur-row">
          <div><strong>LAKSMI Libur</strong><small>{st.can_toggle_libur ? "Berlaku untuk hari ini saja." : "Hanya dapat diaktifkan hari Selasa/Kamis pukul 09.00-11.00 WIB."}</small></div>
          <Toggle checked={st.is_libur} disabled={!st.can_toggle_libur || busy === "libur"} onChange={toggleLibur} testid="laksmi-libur-toggle" />
        </div>
      </section>

      {notice && <p className="laksmi-notice" data-testid="laksmi-admin-notice">{notice}</p>}
      {error && <p className="laksmi-error" data-testid="laksmi-admin-error">{error}</p>}
    </div>
  );
}
